import { ValueLabel } from "@features/ax/shared/ValueLabel";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { navigateToMap } from "@shared/utils/utils";
import { ArrowLeft, Building, MapPin } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
interface SystemProfileCardProps {
  data: {
    systemNo: string;
    systemName: string;
    systemTypeDisplay: string;
    commissionedDate: string;
    physicalAddress: string;
    geoLocation: string;
    description: string;
    location: string;
    contactPersonName: string;
    contactEmail: string;
    statusDisplay: string;
    latitude: string;
    longitude: string;
  };
}
export const SystemProfileCard: React.FC<SystemProfileCardProps> = ({
  data,
}) => {
  const navigate = useNavigate();

  const systemsFields = [
    { label: "System ID", value: data?.systemNo || "NA" },
    { label: "System Name", value: data?.systemName || "NA" },
    { label: "System Type", value: data?.systemTypeDisplay || "NA" },
    { label: "Commission Date", value: data?.commissionedDate || "NA" },
    { label: "Contact Person", value: data?.contactPersonName || "NA" },
    { label: "Contact", value: data?.contactEmail || "NA" },
    { label: "Status", value: data?.statusDisplay || "NA" },
  ];
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate(-1)}
          />
          <Building className="h-5 w-5 text-blue-600" />
          <CardTitle className="text-lg font-semibold">
            {data?.systemNo}
          </CardTitle>
        </div>
        <p className="text-sm text-gray-600">
          Comprehensive system information and operational details
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {systemsFields.map((field, index) => (
            <ValueLabel label={field.label} value={field.value} />
          ))}
        </div>
        <div>
          <p className="text-xs text-muted-foreground tracking-wide">
            Location
          </p>
          <p className="mt-1 text-sm font-medium text-foreground flex gap-2">
            {data?.location || "NA"}
            <Button
              variant="ghost"
              size="sm"
              className="text-blue-600 p-0 h-auto"
              onClick={() => navigateToMap(data?.latitude, data?.longitude)}
            >
              <MapPin className="h-4 w-4 mr-0" />
              View on map
            </Button>
          </p>
        </div>

        <div>
          <p className="text-xs text-muted-foreground tracking-wide">
            Description
          </p>
          <p className="mt-1 text-sm font-medium text-foreground">
            {data?.description || "NA"}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
